import { directionForLocale } from '../i18n';
import type { PromotionAssetViewModel, PromotionTarget } from '../types/promotion-kit';
import type { SupportedLocale } from '../i18n';

export function buildPromotionAssetViewModel(input: {
  readonly storeName: string;
  readonly target: PromotionTarget;
  readonly publicUrl: string;
  readonly locale: SupportedLocale;
}): PromotionAssetViewModel {
  return {
    storeName: input.storeName,
    targetTitle: input.target.title,
    targetSubtitle: input.target.subtitle,
    publicUrl: input.publicUrl,
    imageUrl: input.target.imageUrl,
    locale: input.locale,
    direction: directionForLocale(input.locale),
    ctaKey:
      input.target.type === 'review_highlight'
        ? 'promotionKit.story.cta'
        : 'promotionKit.poster.cta',
  };
}
